import { XIcon } from '@heroicons/react/outline';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';

export default function ManageSubscriptionModal({ showModal, setShowModal }) {
  const router = useRouter();

  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      open={showModal}
      onClose={() => setShowModal(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Fade in={showModal}>
        <div className='inline-block align-bottom  bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm md:max-w-md  xl:max-w-4xl w-full sm:p-6'>
          <div className='flex justify-between '>
            <Image src='/exactbuyer-logo-with-text.svg' alt='Microsoft' width={250} height={60} />
            <button
              type='button'
              className=' bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 right-0'
              onClick={() => setShowModal(false)}
            >
              <XIcon className='h-6 w-6' aria-hidden='true' />
            </button>
          </div>
          <div className='ml-8'>
            <h3 className='mt-12  text-exact-blue text-md uppercase tracking-wide'>
              Account inactive
            </h3>
            <h3 className='text-4xl font-open_sans mt-2'>Your ExactBuyer account is inactive.</h3>
            <h3 className='text-2xl font-open_sans mt-4 mb-8'>
              Want to keep using ExactBuyer? Select a plan that suits your need!
            </h3>
            <button
              type='button'
              className=' w-full inline-flex justify-center rounded-md border border-indigo-800 shadow-sm px-4 py-2 bg-exact-blue text-base font-medium text-gray-50 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500  sm:w-auto sm:text-sm'
              onClick={() => {
                setShowModal(false);
                router.push('/pricing');
              }}
            >
              View Pricing Plans
            </button>
          </div>
          <footer className='shrink-0 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 mt-16'>
            <nav className='flex justify-center space-x-4 items-center'>
              <a
                href='mailto:support@exactbuyer.com'
                className='text-sm font-medium text-gray-500 hover:text-indigo-600'
              >
                Contact Support via email
              </a>
              <span className=' text-gray-400 '>|</span>
              <div
                onClick={() => {
                  setShowModal(false);
                  router.push('/talk-to-sales');
                }}
                className='text-sm font-medium text-gray-500 hover:text-indigo-600 cursor-pointer'
              >
                Set a meeting
              </div>
            </nav>
          </footer>
        </div>
      </Fade>
    </Modal>
  );
}
